import React from 'react';
import AppealsSection from '../../../sections/AdminDashboard/Appeals/Appeals';

const Appeals = () => <AppealsSection />;

export default Appeals;
